module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name + '-modal',
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    class: _vm.cclass
  }, [_vm._t("default", [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          div.modal-header\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          div.modal-body\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._v("\n          div.modal-footer\n        ")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e5df89","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/Modal.vue
// module id = 1702
// module chunks = 6